import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { type AgentExample } from '@/features/checking/domains/common/services/base-example-service';
import { I18nService } from '@/services/i18n-service'

export const HiroExampleService = Symbol('HiroExampleService');
export interface HiroExampleService {
    getExamples(): AgentExample[];
}

@injectable()
export class HiroExampleServiceImpl implements HiroExampleService {
    @inject(I18nService)
    private i18nService!: I18nService;

    getExamples(): AgentExample[] {
        return [
            {
                text: this.i18nService.t('hiro.example1'),
                other: null,
            },
            {
                text: this.i18nService.t('hiro.example2'),
                other: null,
            },
            {
                text: this.i18nService.t('hiro.example3'),
                other: null,
            }
        ];
    }
}
